import store from "@/store";
import requestService from "@/service/requestService";
import { Utils } from "@/service/util";
import { SknUketsukeUserJouhou, SeibiItemSave } from '@/model/CustomerSave';
import { INSPECT_TYPE } from "@/model/InspectType";
import { SeibiItem } from '@/model/InspectionSeibi';

export class UserService {
  reqService: requestService;
  uketsukeExtendsId: number;
  uketsukeCd: string;
  yoyakuNo: string;
  utils: Utils;
  sknSeibiShubetsuKbn: number;

  constructor() {
    this.utils = new Utils();
    this.reqService = new requestService();
    this.uketsukeExtendsId =
      store.getters["ReservationDetail/uketsukeExtendsId"];
    this.uketsukeCd = store.getters["ReservationDetail/uketsukeCd"];
    this.yoyakuNo = store.getters["ReservationDetail/yoyakuNo"];
    this.sknSeibiShubetsuKbn =
      store.getters["ReservationDetail/sknSeibiShubetsuKbn"];
  }

  // 現車・57(ユーザー側)
  getSeibi() {
    if (!this.isLoading("seibi")) {
      this.setLoading("seibi", true);
      this.reqService.getInspectSeibi(this.uketsukeExtendsId).then(
        (res: any) => {
          const seibi = { ...res };
          delete seibi.items.sknWorkProgressState;
          delete seibi.items.sknWorkProgressStateNm;
          const data = { ...seibi };
          store.dispatch("InspectionDetail/setProgressState", {
            stateId: res.items.sknWorkProgressState,
            stateNm: res.items.sknWorkProgressStateNm
          });
          store.dispatch("InspectSeibi/setSeibiData", data); // inspectSeibiStoreデータセット
          // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
          let isJizenSort = false;
          this.reqService.checkJizenSort(this.uketsukeExtendsId).then((jizenResult: any) => {
            isJizenSort = jizenResult;
            if (!isJizenSort) {
              // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
              const listInspectByType = store.getters[`InspectSeibi/listInspectByType`](1);
              store.dispatch("InspectSeibi/setListInspectId", listInspectByType);
              // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [START]
            }
          });
          // 2023-10-00 BQR1092(809) add 明細の並び順とextreme取込 [END]
          this.setLoading("seibi", false);
        },
        (err: any) => {
          this.setError("seibi", err);
        }
      );
    }
  }

  // 整備対象リスト用意(ユーザー側)
  getSeibiAK3() {
    if (!this.isLoading("seibiAK3")) {
      // if (!store.getters["InspectSeibiAK3/hasData"]) {
        this.setLoading("seibiAK3", true);
      // }
      this.reqService.getInspectSeibiAK3_1(this.uketsukeExtendsId).then(
        (res: any) => {
          const seibi = { ...res };
          delete seibi.sknWorkProgressState;
          delete seibi.sknWorkProgressStateNm;
          const data = { ...seibi };
          store.dispatch("InspectionDetail/setProgressState", {
            stateId: res.sknWorkProgressState,
            stateNm: res.sknWorkProgressStateNm
          });
          store.dispatch("InspectSeibiAK3/setSeibiData", data);
          this.setLoading("seibiAK3", false);
        },
        (err: any) => {
          this.setError("seibiAK3", err);
        }
      );
    }
  }

  /** 2021-05-18 sh #7101 fix shaken kensa hiyou [START] */
  /*
  *   getShohiyou() {
  *     if (!this.isLoading("shohiyou")) {
  *       this.setLoading("shohiyou", true);
  *       this.reqService.getInsectionCost(this.uketsukeExtendsId).then(
  *         (response: any) => {
  *           if (response) {
  *             let shakenHiyouItem = [];
  *             if (response.shakenHiyou.items) {
  *               shakenHiyouItem = response.shakenHiyou.items.filter((item: any, index: number) => {
  *                 return index === response.shakenHiyou.items.findIndex((obj: any) => {
  *                   return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
  *                 });
  *               });
  *             }
  *             response.shakenHiyou.items = shakenHiyouItem;
  *             store.dispatch("Shohiyou/setShakenShohiyou", response);
  *             this.setLoading("shohiyou", false);
  *           }
  *         },
  *         (err: any) => {
  *           this.setError("shohiyou", err);
  *         }
  *       );
  *     }
  *   }
  */
  getShohiyou() {
    if (!this.isLoading("shohiyou")) {
      this.setLoading("shohiyou", true);
      let promise = this.getShohiyouPM();
      Promise.all([promise]).then(() => {
        this.setLoading("shohiyou", false);
      });
    }
  }

  getShohiyouPM() {
    let promise = new Promise((resolve, reject) => {
      this.reqService.getInsectionCost(this.uketsukeExtendsId).then(
        (response: any) => {
          if (response) {
            let shakenHiyouItem = [];
            if (response.shakenHiyou.items) {
              shakenHiyouItem = response.shakenHiyou.items.filter((item: any, index: number) => {
                return index === response.shakenHiyou.items.findIndex((obj: any) => {
                  return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
                });
              });
            }
            response.shakenHiyou.items = shakenHiyouItem;
            response.kensaHiyou.items = response.kensaHiyou.items || [];
            store.dispatch("Shohiyou/setShakenShohiyou", response);
          }
          resolve();
        },
        (err: any) => {
          this.setError("shohiyou", err);
          reject();
        }
      );
    });
    return promise;
  }

  getKensaHiyouPM() {
    let promise = new Promise((resolve, reject) => {
      this.reqService.getInsectionCost(this.uketsukeExtendsId).then(
        (response: any) => {
          if (response) {
            let shakenHiyouItem = [];
            if (response.shakenHiyou.items) {
              shakenHiyouItem = response.shakenHiyou.items.filter((item: any, index: number) => {
                return index === response.shakenHiyou.items.findIndex((obj: any) => {
                  return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
                });
              });
            }
            response.shakenHiyou.items = shakenHiyouItem;
            store.dispatch("Shohiyou/updateKensaHiyou", response);
          }
          resolve();
        },
        (err: any) => {
          this.setError("shohiyou", err);
          reject();
        }
      );
    });
    return promise;
  }
  /** 2021-05-18 sh #7101 fix shaken kensa hiyou [END] */

  getShohiyouQM() {
    if (!this.isLoading("shohiyou")) {
      this.setLoading("shohiyou", true);
      this.reqService.getInsectionCostQM(this.uketsukeExtendsId).then(
        (response: any) => {
          if (response) {
            let shakenHiyouItem = [];
            if (response.shakenHiyou.items) {
              shakenHiyouItem = response.shakenHiyou.items.filter((item: any, index: number) => {
                return index === response.shakenHiyou.items.findIndex((obj: any) => {
                  return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
                });
              });
            }
            response.shakenHiyou.items = shakenHiyouItem;
            response.kensaHiyou.items = response.kensaHiyou.items || [];
            store.dispatch("Shohiyou/setShakenShohiyou", response);
            this.setLoading("shohiyou", false);
          }
        },
        (err: any) => {
          this.setError("shohiyou", err);
        }
      );
    }
  }

  getCoupon() {
    if (!this.isLoading("coupon")) {
      const seibiKbn = this.sknSeibiShubetsuKbn ? this.sknSeibiShubetsuKbn : 0;
      this.setLoading("coupon", true);
      this.reqService.getCoupon(this.uketsukeExtendsId, seibiKbn).then(
        (response: any) => {
          if (response) {
            store.dispatch("Coupon/setCouponFromServer", response);
            this.setLoading("coupon", false);
          }
        },
        (err: any) => {
          this.setError("coupon", err);
        }
      );
      this.reqService
      .getCouponLimit(
      )
      .then((res: any) => {
        if (res) {
          store.dispatch("Coupon/setCoupon2", res.couponLimitZn);
          store.dispatch("Coupon/setCoupon3", res.couponLimitZk);
          // this.couponLimitZn = res.couponLimitZn;
          // const limit = util.getNumberThousandSeparate(this.couponLimitZn);
        }
      });
    }
  }

  updateConfirm(obj: SknUketsukeUserJouhou) {
    /** 2021-05-27 sh #7123 if change price, change the flag. fix if [START] */
    // if (obj.isConfirmHiyou) {
    if (obj && obj.hasOwnProperty("isConfirmHiyou") && obj.isConfirmHiyou != null) {
      store.dispatch("Shohiyou/confirm", obj.isConfirmHiyou);
    }
    // if (obj.isConfirmCoupon) {
    if (obj && obj.hasOwnProperty("isConfirmCoupon") && obj.isConfirmCoupon != null) {
      store.dispatch("Coupon/confirm", obj.isConfirmCoupon);
    }
    // if (obj.isConfirmInspect) {
    if (obj && obj.hasOwnProperty("isConfirmInspect") && obj.isConfirmInspect != null) {
      store.dispatch("InspectSeibi/confirm", {
        type: INSPECT_TYPE.LEGAL56,
        value: obj.isConfirmInspect
      });
    }
    // if (obj.isConfirmRecommend) {
    if (obj && obj.hasOwnProperty("isConfirmRecommend") && obj.isConfirmRecommend != null) {
      store.dispatch("InspectSeibi/confirm", {
        type: INSPECT_TYPE.RECOMMEND,
        value: obj.isConfirmRecommend
      });
    }
    if (obj && obj.hasOwnProperty("isConfirmOption") && obj.isConfirmOption != null) {
      store.dispatch("Option/confirm", obj.isConfirmOption);
    }
    /** 2021-05-27 sh #7123 if change price, change the flag. fix if [END] */
  }

  getConfirm() {
    this.reqService.getIsConfirm(this.uketsukeExtendsId).then(
      (response: any) => {
        if (response) {
          const obj: SknUketsukeUserJouhou = response;
          this.updateConfirm(obj);
          store.dispatch("Payment/confirm", obj.isConfirmPayment);
        }
      },
      (err: any) => { }
    );
  }

  // getDataToSync() {
  //   // ak-0002
  //   this.getShohiyou();

  //   // ak-0006
  //   this.getCoupon();
  //   this.getConfirm();
  // }

  getAllData(hasRyoukinRank: boolean = true) {
    // confirm
    this.getConfirm();

    // ak-0003 - 0005
    this.getSeibi();
    this.getSeibiAK3(); // 整備対象リスト用意(ユーザー側)

    // ak-0002
    if (hasRyoukinRank) {
      this.getShohiyou();
    }

    // ak-0006
    this.getCoupon();
    this.getOption();

  }

  getAllDataQM() {
    // confirm
    this.getConfirm();

    // ak-0003 - 0005
    this.getSeibi();
    this.getSeibiAK3(); // 整備対象リスト用意(ユーザー側)

    // ak-0002
    this.getShohiyouQM();

    // ak-0006
    this.getCoupon();
    this.getOption();

  }

  setError(key: string, error: any) {
    const value = this.utils.getHttpErrorMessage(error);
    store.dispatch("UserDataState/setError", { key, value });
    this.setLoading(key, false);
  }

  setLoading(key: string, isLoading: boolean) {
    store.dispatch("UserDataState/setLoading", { key, value: isLoading });
  }

  isLoading(key: string) {
    return store.getters[`UserDataState/${key}Loading`];
  }

  getDataForSaveAk7(seibi: any, seibiManual: any, sumPriceLegal56: any,
    sumPriceRecommend: any) {
    let seibiList: any = {};
    let manualSeibis: any[] = [];
    if (seibi.length > 0) {
      if (seibi.length == 5) {
        seibi = seibi.slice(0, 4);
      }
      seibi.forEach((seibiGroup: SeibiItem[], i: number) => {
        let mapSeibi: any = [];
        try {
          if (seibiGroup && seibiGroup.length > 0) {
            // seibi = seibi.filter((item: SeibiItem) => {
            //   return ((item.sknInspectType <= 1 && item.inspectResult > 1) || item.sknInspectType > 1);
            // });
            mapSeibi = seibiGroup
              .filter((item: SeibiItem) => item.sknUketsukeManualSeibiId == null)
              .map((item: SeibiItem) => {
              let seibiSave: SeibiItemSave = {
                sknUketsukeExtendsId: item.sknUketsukeExtendsId,
                sknUketsukeInspectSeibiId: item.sknInspectSeibiId,
                doTenken: item.doTenken,
                koukanMeyasuTime: item.koukanMeyasuTime,
                buhinZk: item.buhinZk ? +item.buhinZk : 0,
                kouchinZk: item.kouchinZk ? +item.kouchinZk : 0,
              };
              return { ...seibiSave };
            });
            manualSeibis = manualSeibis.concat(
              seibiGroup
                .filter((item: SeibiItem) => item.sknUketsukeManualSeibiId != null)
                .map((item: SeibiItem) => ({
                  sknUketsukeExtendsId: item.sknUketsukeExtendsId,
                  sknUketsukeManualSeibiId: item.sknUketsukeManualSeibiId,
                  doTenken: item.doTenken,
                  buhinZk: item.buhinZk ? +item.buhinZk : 0,
                  kouchinZk: item.kouchinZk ? +item.kouchinZk : 0,
                }))
            );
          }
        } catch (ex) {
          console.log(ex);
        }
        seibiList[i.toString()] = mapSeibi;
      });
    }
    let seibiManualList: any = {};
    if (seibiManual && seibiManual.length > 0) {
      manualSeibis = manualSeibis.concat(seibiManual.map((item: any) => {
        return {
          sknUketsukeExtendsId: item.sknUketsukeExtendsId,
          sknUketsukeManualSeibiId: item.sknUketsukeManualSeibiId,
          doTenken: item.doTenken,
          buhinZk: item.buhinZk ? +item.buhinZk : 0,
          kouchinZk: item.kouchinZk ? +item.kouchinZk : 0,
        };
      }));
    }
    if (manualSeibis.length > 0) {
      seibiManualList = { "2": manualSeibis };
    }
    const shakenShohiyou = store.getters["Shohiyou/dataForSavePayment"];
    const coupon = store.getters["Coupon/currentState"];
    const isConfirmLegal56 = store.getters["InspectSeibi/isConfirmLegal56"];
    const isConfirmRecommend = store.getters["InspectSeibi/isConfirmRecommend"];
    const totalShohiyou = store.getters["Shohiyou/total"];
    const totalCoupon = store.getters["Coupon/total"];
    let sumZk = 0;
    const sumShohiyou = totalShohiyou.totalZk || 0;
    const sumCoupon = totalCoupon.subTotalZk || 0;
    const sumRecommend = sumPriceRecommend.totalZk || 0;
    const sumLegal = sumPriceLegal56.totalZk || 0;
    sumZk = sumShohiyou + sumCoupon + sumRecommend + sumLegal;
    const option = store.getters["Option/currentState"];
    const totalOption = store.getters["Option/total"];

    const dataForSave = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      sknUketsukeExtends: {
        isHikazei: 0,
        sknPaymentZn: null,
        sknPaymentZk: sumZk
      },
      inspectSeibi: {
        subTotalLegalZn: null,
        subTotalLegalZk: sumLegal,
        subTotalRecommendZn: null,
        subTotalRecommendZk: sumRecommend,
        isHikazei: 0,
        items: seibiList,
        manualItems: seibiManualList
      },
      shakenShohiyou: shakenShohiyou,
      coupon: coupon.coupon,
      proposal: coupon.proposal,
      sknUketsukeUserJouhou: {
        isConfirmHiyou: shakenShohiyou.isConfirm
          ? shakenShohiyou.isConfirm
          : 0,
        isConfirmCoupon: coupon.isConfirm
          ? coupon.isConfirm
          : 0,
        isConfirmInspect: isConfirmLegal56,
        isConfirmRecommend: isConfirmRecommend,
        isConfirmPayment: 1
      }
      ,option: option.option
    };
    return dataForSave;
  }


  autoSaveAk7() {
    if (store.getters["Payment/isConfirm"] == 1) {
      const dataForSave = this.getDataForSaveAk7(
        store.getters["InspectSeibi/getSeibiData"],
        store.getters["InspectSeibi/getManualSeibiData"],
        store.getters["InspectSeibi/sumPriceByType"](INSPECT_TYPE.LEGAL56),
        store.getters["InspectSeibi/sumPriceByType"](INSPECT_TYPE.RECOMMEND)
      );
      this.reqService.savePayment(dataForSave); // sendSocket:ソケット仮34
    }
  }

  getOption() {
    if (!this.isLoading("option")) {
      const seibiKbn = this.sknSeibiShubetsuKbn ? this.sknSeibiShubetsuKbn : 0;
      this.setLoading("option", true);
      this.reqService.getOption(this.uketsukeExtendsId, seibiKbn).then(
        (response: any) => {
          if (response) {
            store.dispatch("Option/setOptionFromServer", response);
            this.setLoading("option", false);
          }
        },
        (err: any) => {
          this.setError("option", err);
        }
      );
    }
  }

  /** 2021-06-02 sh #7123 if change price, get the flag from server. [START] */
  getConfirmPM() {
    let promise = new Promise((resolve, reject) => {
      this.reqService.getIsConfirm(this.uketsukeExtendsId).then(
        (response: any) => {
          if (response) {
            const obj: SknUketsukeUserJouhou = response;
            this.updateConfirm(obj);
            store.dispatch("Payment/confirm", obj.isConfirmPayment);
          }
          resolve();
        },
        (err: any) => { reject(); }
      );
    });
    return promise;
  }
  /** 2021-06-02 sh #7123 if change price, get the flag from server. [END] */

  /** 2021-07-09 sh #7131 it get option from server after save. [START] */
  getOptionPM() {
    const seibiKbn = this.sknSeibiShubetsuKbn ? this.sknSeibiShubetsuKbn : 0;
    let promise = new Promise((resolve, reject) => {
      this.reqService.getOption(this.uketsukeExtendsId, seibiKbn).then(
        (response: any) => {
          if (response) {
            store.dispatch("Option/setOptionFromServer", response);
          }
          resolve();
        },
        (err: any) => { reject(); }
      );
    });
    return promise;
  }
  /** 2021-07-09 sh #7131 it get option from server after save. [END] */

  /** 2021-07-27 sh #6989 implements quick mitsumori for priority2. [START] */
  getPrefecturesPM() {
    const promise = new Promise((resolve, reject) => {
      this.reqService.getPrefectures().then(list => {
        resolve(list);
      }, (err: any) => {
        reject();
      });
    });
    return promise;
  }

  getLaborRatePM() {
    const promise = new Promise((resolve, reject) => {
      this.reqService.getLaborRate().then((res: any) => {
        if (res && res.length > 0) {
          resolve(res);
        }
      }, (err: any) => {
        reject();
      });
    });
    return promise;
  }

  getPlateAreasFrequentPM() {
    const promise = new Promise((resolve, reject) => {
      this.reqService.getPlateAreasFrequent().then(list => {
        resolve(list);
      }, (err: any) => {
        reject();
      });
    });
    return promise;
  }
  /** 2021-07-27 sh #6989 implements quick mitsumori for priority2. [END] */
}
